export interface ILabelValueConstant {
    label:string,
    value:string
}

export interface IIDNAmeConstant {
    id:number,
    name:string
}

export const ValidationPatterns = {
    OTP: /^\d{6}$/,
};


/**
 * all country array that will use in droplist
 */
export const constants = { 
    contries: [
        {
            label: "Select country",
            value: "0"
        },
        {
            label: "Afghanistan",
            value: "AF"
        },
        {
            label: "Aland Islands",
            value: "AX"
        },
        {
            label: "Albania",
            value: "AL"
        },
        {
            label: "Algeria",
            value: "DZ"
        },
        {
            label: "American Samoa",
            value: "AS"
        },
        {
            label: "Andorra",
            value: "AD"
        },
        {
            label: "Angola",
            value: "AO"
        },
        {
            label: "Anguilla",
            value: "AI"
        },
        {
            label: "Antarctica",
            value: "AQ"
        },
        {
            label: "Antigua And Barbuda",
            value: "AG"
        },
        {
            label: "Argentina",
            value: "AR"
        },
        {
            label: "Armenia",
            value: "AM"
        },
        {
            label: "Aruba",
            value: "AW"
        },
        {
            label: "Australia",
            value: "AU"
        },
        {
            label: "Austria",
            value: "AT"
        },
        {
            label: "Azerbaijan",
            value: "AZ"
        },
        {
            label: "Bahamas",
            value: "BS"
        },
        {
            label: "Bahrain",
            value: "BH"
        },
        {
            label: "Bangladesh",
            value: "BD"
        },
        {
            label: "Barbados",
            value: "BB"
        },
        {
            label: "Belarus",
            value: "BY"
        },
        {
            label: "Belgium",
            value: "BE"
        },
        {
            label: "Belize",
            value: "BZ"
        },
        {
            label: "Benin",
            value: "BJ"
        },
        {
            label: "Bermuda",
            value: "BM"
        },
        {
            label: "Bhutan",
            value: "BT"
        },
        {
            label: "Bolivia",
            value: "BO"
        },
        {
            label: "Bosnia And Herzegovina",
            value: "BA"
        },
        {
            label: "Botswana",
            value: "BW"
        },
        {
            label: "Bouvet Island",
            value: "BV"
        },
        {
            label: "Brazil",
            value: "BR"
        },
        {
            label: "British Indian Ocean Territory",
            value: "IO"
        },
        {
            label: "Brunei Darussalam",
            value: "BN"
        },
        {
            label: "Bulgaria",
            value: "BG"
        },
        {
            label: "Burkina Faso",
            value: "BF"
        },
        {
            label: "Burundi",
            value: "BI"
        },
        {
            label: "Cambodia",
            value: "KH"
        },
        {
            label: "Cameroon",
            value: "CM"
        },
        {
            label: "Canada",
            value: "CA"
        },
        {
            label: "Cape Verde",
            value: "CV"
        },
        {
            label: "Cayman Islands",
            value: "KY"
        },
        {
            label: "Central African Republic",
            value: "CF"
        },
        {
            label: "Chad",
            value: "TD"
        },
        {
            label: "Chile",
            value: "CL"
        },
        {
            label: "China",
            value: "CN"
        },
        {
            label: "Christmas Island",
            value: "CX"
        },
        {
            label: "Cocos (Keeling) Islands",
            value: "CC"
        },
        {
            label: "Colombia",
            value: "CO"
        },
        {
            label: "Comoros",
            value: "KM"
        },
        {
            label: "Congo",
            value: "CG"
        },
        {
            label: "Congo, Democratic Republic",
            value: "CD"
        },
        {
            label: "Cook Islands",
            value: "CK"
        },
        {
            label: "Costa Rica",
            value: "CR"
        },
        {
            label: "Cote D'Ivoire",
            value: "CI"
        },
        {
            label: "Croatia",
            value: "HR"
        },
        {
            label: "Cuba",
            value: "CU"
        },
        {
            label: "Cyprus",
            value: "CY"
        },
        {
            label: "Czech Republic",
            value: "CZ"
        },
        {
            label: "Denmark",
            value: "DK"
        },
        {
            label: "Djibouti",
            value: "DJ"
        },
        {
            label: "Dominica",
            value: "DM"
        },
        {
            label: "Dominican Republic",
            value: "DO"
        },
        {
            label: "Ecuador",
            value: "EC"
        },
        {
            label: "Egypt",
            value: "EG"
        },
        {
            label: "El Salvador",
            value: "SV"
        },
        {
            label: "Equatorial Guinea",
            value: "GQ"
        },
        {
            label: "Eritrea",
            value: "ER"
        },
        {
            label: "Estonia",
            value: "EE"
        },
        {
            label: "Ethiopia",
            value: "ET"
        },
        {
            label: "Falkland Islands (Malvinas)",
            value: "FK"
        },
        {
            label: "Faroe Islands",
            value: "FO"
        },
        {
            label: "Fiji",
            value: "FJ"
        },
        {
            label: "Finland",
            value: "FI"
        },
        {
            label: "France",
            value: "FR"
        },
        {
            label: "French Guiana",
            value: "GF"
        },
        {
            label: "French Polynesia",
            value: "PF"
        },
        {
            label: "French Southern Territories",
            value: "TF"
        },
        {
            label: "Gabon",
            value: "GA"
        },
        {
            label: "Gambia",
            value: "GM"
        },
        {
            label: "Georgia",
            value: "GE"
        },
        {
            label: "Germany",
            value: "DE"
        },
        {
            label: "Ghana",
            value: "GH"
        },
        {
            label: "Gibraltar",
            value: "GI"
        },
        {
            label: "Greece",
            value: "GR"
        },
        {
            label: "Greenland",
            value: "GL"
        },
        {
            label: "Grenada",
            value: "GD"
        },
        {
            label: "Guadeloupe",
            value: "GP"
        },
        {
            label: "Guam",
            value: "GU"
        },
        {
            label: "Guatemala",
            value: "GT"
        },
        {
            label: "Guernsey",
            value: "GG"
        },
        {
            label: "Guinea",
            value: "GN"
        },
        {
            label: "GuineaBissau",
            value: "GW"
        },
        {
            label: "Guyana",
            value: "GY"
        },
        {
            label: "Haiti",
            value: "HT"
        },
        {
            label: "Heard Island & Mcdonald Islands",
            value: "HM"
        },
        {
            label: "Holy See (Vatican City State)",
            value: "VA"
        },
        {
            label: "Honduras",
            value: "HN"
        },
        {
            label: "Hong Kong",
            value: "HK"
        },
        {
            label: "Hungary",
            value: "HU"
        },
        {
            label: "Iceland",
            value: "IS"
        },
        {
            label: "India",
            value: "IN"
        },
        {
            label: "Indonesia",
            value: "ID"
        },
        {
            label: "Iran, Islamic Republic Of",
            value: "IR"
        },
        {
            label: "Iraq",
            value: "IQ"
        },
        {
            label: "Ireland",
            value: "IE"
        },
        {
            label: "Isle Of Man",
            value: "IM"
        },
        {
            label: "Israel",
            value: "IL"
        },
        {
            label: "Italy",
            value: "IT"
        },
        {
            label: "Jamaica",
            value: "JM"
        },
        {
            label: "Japan",
            value: "JP"
        },
        {
            label: "Jersey",
            value: "JE"
        },
        {
            label: "Jordan",
            value: "JO"
        },
        {
            label: "Kazakhstan",
            value: "KZ"
        },
        {
            label: "Kenya",
            value: "KE"
        },
        {
            label: "Kiribati",
            value: "KI"
        },
        {
            label: "Korea",
            value: "KR"
        },
        {
            label: "Kuwait",
            value: "KW"
        },
        {
            label: "Kyrgyzstan",
            value: "KG"
        },
        {
            label: "Lao People's Democratic Republic",
            value: "LA"
        },
        {
            label: "Latvia",
            value: "LV"
        },
        {
            label: "Lebanon",
            value: "LB"
        },
        {
            label: "Lesotho",
            value: "LS"
        },
        {
            label: "Liberia",
            value: "LR"
        },
        {
            label: "Libyan Arab Jamahiriya",
            value: "LY"
        },
        {
            label: "Liechtenstein",
            value: "LI"
        },
        {
            label: "Lithuania",
            value: "LT"
        },
        {
            label: "Luxembourg",
            value: "LU"
        },
        {
            label: "Macao",
            value: "MO"
        },
        {
            label: "Macedonia",
            value: "MK"
        },
        {
            label: "Madagascar",
            value: "MG"
        },
        {
            label: "Malawi",
            value: "MW"
        },
        {
            label: "Malaysia",
            value: "MY"
        },
        {
            label: "Maldives",
            value: "MV"
        },
        {
            label: "Mali",
            value: "ML"
        },
        {
            label: "Malta",
            value: "MT"
        },
        {
            label: "Marshall Islands",
            value: "MH"
        },
        {
            label: "Martinique",
            value: "MQ"
        },
        {
            label: "Mauritania",
            value: "MR"
        },
        {
            label: "Mauritius",
            value: "MU"
        },
        {
            label: "Mayotte",
            value: "YT"
        },
        {
            label: "Mexico",
            value: "MX"
        },
        {
            label: "Micronesia, Federated States Of",
            value: "FM"
        },
        {
            label: "Moldova",
            value: "MD"
        },
        {
            label: "Monaco",
            value: "MC"
        },
        {
            label: "Mongolia",
            value: "MN"
        },
        {
            label: "Montenegro",
            value: "ME"
        },
        {
            label: "Montserrat",
            value: "MS"
        },
        {
            label: "Morocco",
            value: "MA"
        },
        {
            label: "Mozambique",
            value: "MZ"
        },
        {
            label: "Myanmar",
            value: "MM"
        },
        {
            label: "Namibia",
            value: "NA"
        },
        {
            label: "Nauru",
            value: "NR"
        },
        {
            label: "Nepal",
            value: "NP"
        },
        {
            label: "Netherlands",
            value: "NL"
        },
        {
            label: "Netherlands Antilles",
            value: "AN"
        },
        {
            label: "New Caledonia",
            value: "NC"
        },
        {
            label: "New Zealand",
            value: "NZ"
        },
        {
            label: "Nicaragua",
            value: "NI"
        },
        {
            label: "Niger",
            value: "NE"
        },
        {
            label: "Nigeria",
            value: "NG"
        },
        {
            label: "Niue",
            value: "NU"
        },
        {
            label: "Norfolk Island",
            value: "NF"
        },
        {
            label: "Northern Mariana Islands",
            value: "MP"
        },
        {
            label: "Norway",
            value: "NO"
        },
        {
            label: "Oman",
            value: "OM"
        },
        {
            label: "Pakistan",
            value: "PK"
        },
        {
            label: "Palau",
            value: "PW"
        },
        {
            label: "Palestinian Territory, Occupied",
            value: "PS"
        },
        {
            label: "Panama",
            value: "PA"
        },
        {
            label: "Papua New Guinea",
            value: "PG"
        },
        {
            label: "Paraguay",
            value: "PY"
        },
        {
            label: "Peru",
            value: "PE"
        },
        {
            label: "Philippines",
            value: "PH"
        },
        {
            label: "Pitcairn",
            value: "PN"
        },
        {
            label: "Poland",
            value: "PL"
        },
        {
            label: "Portugal",
            value: "PT"
        },
        {
            label: "Puerto Rico",
            value: "PR"
        },
        {
            label: "Qatar",
            value: "QA"
        },
        {
            label: "Reunion",
            value: "RE"
        },
        {
            label: "Romania",
            value: "RO"
        },
        {
            label: "Russian Federation",
            value: "RU"
        },
        {
            label: "Rwanda",
            value: "RW"
        },
        {
            label: "Saint Barthelemy",
            value: "BL"
        },
        {
            label: "Saint Helena",
            value: "SH"
        },
        {
            label: "Saint Kitts And Nevis",
            value: "KN"
        },
        {
            label: "Saint Lucia",
            value: "LC"
        },
        {
            label: "Saint Martin",
            value: "MF"
        },
        {
            label: "Saint Pierre And Miquelon",
            value: "PM"
        },
        {
            label: "Saint Vincent And Grenadines",
            value: "VC"
        },
        {
            label: "Samoa",
            value: "WS"
        },
        {
            label: "San Marino",
            value: "SM"
        },
        {
            label: "Sao Tome And Principe",
            value: "ST"
        },
        {
            label: "Saudi Arabia",
            value: "SA"
        },
        {
            label: "Senegal",
            value: "SN"
        },
        {
            label: "Serbia",
            value: "RS"
        },
        {
            label: "Seychelles",
            value: "SC"
        },
        {
            label: "Sierra Leone",
            value: "SL"
        },
        {
            label: "Singapore",
            value: "SG"
        },
        {
            label: "Slovakia",
            value: "SK"
        },
        {
            label: "Slovenia",
            value: "SI"
        },
        {
            label: "Solomon Islands",
            value: "SB"
        },
        {
            label: "Somalia",
            value: "SO"
        },
        {
            label: "South Africa",
            value: "ZA"
        },
        {
            label: "South Georgia And Sandwich Isl.",
            value: "GS"
        },
        {
            label: "Spain",
            value: "ES"
        },
        {
            label: "Sri Lanka",
            value: "LK"
        },
        {
            label: "Sudan",
            value: "SD"
        },
        {
            label: "Suriname",
            value: "SR"
        },
        {
            label: "Svalbard And Jan Mayen",
            value: "SJ"
        },
        {
            label: "Swaziland",
            value: "SZ"
        },
        {
            label: "Sweden",
            value: "SE"
        },
        {
            label: "Switzerland",
            value: "CH"
        },
        {
            label: "Syrian Arab Republic",
            value: "SY"
        },
        {
            label: "Taiwan",
            value: "TW"
        },
        {
            label: "Tajikistan",
            value: "TJ"
        },
        {
            label: "Tanzania",
            value: "TZ"
        },
        {
            label: "Thailand",
            value: "TH"
        },
        {
            label: "TimorLeste",
            value: "TL"
        },
        {
            label: "Togo",
            value: "TG"
        },
        {
            label: "Tokelau",
            value: "TK"
        },
        {
            label: "Tonga",
            value: "TO"
        },
        {
            label: "Trinidad And Tobago",
            value: "TT"
        },
        {
            label: "Tunisia",
            value: "TN"
        },
        {
            label: "Turkey",
            value: "TR"
        },
        {
            label: "Turkmenistan",
            value: "TM"
        },
        {
            label: "Turks And Caicos Islands",
            value: "TC"
        },
        {
            label: "Tuvalu",
            value: "TV"
        },
        {
            label: "Uganda",
            value: "UG"
        },
        {
            label: "Ukraine",
            value: "UA"
        },
        {
            label: "United Arab Emirates",
            value: "AE"
        },
        {
            label: "United Kingdom",
            value: "GB"
        },
        {
            label: "United States",
            value: "US"
        },
        {
            label: "United States Outlying Islands",
            value: "UM"
        },
        {
            label: "Uruguay",
            value: "UY"
        },
        {
            label: "Uzbekistan",
            value: "UZ"
        },
        {
            label: "Vanuatu",
            value: "VU"
        },
        {
            label: "Venezuela",
            value: "VE"
        },
        {
            label: "Viet Nam",
            value: "VN"
        },
        {
            label: "Virgin Islands, British",
            value: "VG"
        },
        {
            label: "Virgin Islands, U.S.",
            value: "VI"
        },
        {
            label: "Wallis And Futuna",
            value: "WF"
        },
        {
            label: "Western Sahara",
            value: "EH"
        },
        {
            label: "Yemen",
            value: "YE"
        },
        {
            label: "Zambia",
            value: "ZM"
        },
        {
            label: "Zimbabwe",
            value: "ZW"
        }
    ],
    
    industries: [
        {
            label: "Select Industry",
            value: "Select Industry"
        },
        {
            label: "Agriculture",
            value: "Agriculture"
        },
        {
            label: "Apparel",
            value: "Apparel"
        },
        {
            label: "Banking",
            value: "Banking"
        },
        {
            label: "Biotechnology",
            value: "Biotechnology"
        },
        {
            label: "Chemicals",
            value: "Chemicals"
        },
        {
            label: "Communications",
            value: "Communications"
        },
        {
            label: "Construction",
            value: "Construction"
        },
        {
            label: "Consulting",
            value: "Consulting"
        },
        {
            label: "Education",
            value: "Education"
        },
        {
            label: "Electronics",
            value: "Electronics"
        },
        {
            label: "Energy",
            value: "Energy"
        },
        {
            label: "Engineering",
            value: "Engineering"
        },
        {
            label: "Entertainment",
            value: "Entertainment"
        },
        {
            label: "Environmental",
            value: "Environmental"
        },
        {
            label: "Finance",
            value: "Finance"
        },
        {
            label: "Food & Beverage",
            value: "Food & Beverage"
        },
        {
            label: "Government",
            value: "Government"
        },
        {
            label: "Healthcare",
            value: "Healthcare"
        },
        {
            label: "Hospitality",
            value: "Hospitality"
        },
        {
            label: "Human Resources",
            value: "Human Resources"
        },
        {
            label: "Insurance",
            value: "Insurance"
        },
        {
            label: "Machinery",
            value: "Machinery"
        },
        {
            label: "Manufacturing",
            value: "Manufacturing"
        },
        {
            label: "Media",
            value: "Media"
        },
        {
            label: "Not For Profit",
            value: "Not For Profit"
        },
        {
            label: "Utilities",
            value: "Utilities"
        },
        {
            label: "Real Estate",
            value: "Real Estate"
        },
        {
            label: "Recreation",
            value: "Recreation"
        },
        {
            label: "Reseller",
            value: "Reseller"
        },
        {
            label: "Retail",
            value: "Retail"
        },
        {
            label: "Shipping",
            value: "Shipping"
        },
        {
            label: "Technology",
            value: "Technology"
        },
        {
            label: "Telecommunications",
            value: "Telecommunications"
        },
        {
            label: "Transportation",
            value: "Transportation"
        },
        {
            label: "Other",
            value: "Other"
        }
    ],

    timezones: [
        {
            label: "(GMT-10:00) Hawaii-Aleutian",
            value: "America/Adak"
        },
        {
            label: "(GMT-09:30) Marquesas Islands",
            value: "Pacific/Marquesas"
        },
        {
            label: "(GMT-09:00) Gambier Islands",
            value: "Pacific/Gambier"
        },
        {
            label: "(GMT-09:00) Alaska",
            value: "America/Anchorage"
        },
        {
            label: "(GMT-08:00) Tijuana, Baja California",
            value: "America/Ensenada"
        },
        {
            label: "(GMT-08:00) Pacific Time (US & Canada)",
            value: "America/Los_Angeles"
        },
        {
            label: "(GMT-07:00) Mountain Time (US & Canada)",
            value: "America/Denver"
        },
        {
            label: "(GMT-07:00): Chihuahua, La Paz, Mazatlan",
            value: "America/Chihuahua"
        },
        {
            label: "(GMT-07:00) Arizona",
            value: "America/Dawson_Creek"
        },
        {
            label: "(GMT-06:00) Saskatchewan, Central America",
            value: "America/Belize"
        },
        {
            label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
            value: "America/Cancun"
        },
        {
            label: "(GMT-06:00) Easter Island",
            value: "Chile/EasterIsland"
        },
        {
            label: "(GMT-06:00) Central Time (US & Canada)",
            value: "America/Chicago"
        },
        {
            label: "(GMT-05:00) Eastern Time (US & Canada)",
            value: "America/New_York"
        },
        {
            label: "(GMT-05:00) Cuba",
            value: "America/Havana"
        },
        {
            label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
            value: "America/Bogota"
        },
        {
            label: "(GMT-04:30) Caracas",
            value: "America/Caracas"
        },
        {
            label: "(GMT-04:00) Santiago",
            value: "America/Santiago"
        },
        {
            label: "(GMT-04:00) La Paz",
            value: "America/La_Paz"
        },
        {
            label: "(GMT-04:00) Faukland Islands",
            value: "Atlantic/Stanley"
        },
        {
            label: "(GMT-04:00) Brazil",
            value: "America/Campo_Grande"
        },
        {
            label: "(GMT-04:00) Atlantic Time (Goose Bay)",
            value: "America/Goose_Bay"
        },
        {
            label: "(GMT-04:00) Atlantic Time (Canada)",
            value: "America/Glace_Bay"
        },
        {
            label: "(GMT-03:30) Newfoundland",
            value: "America/St_Johns"
        },
        {
            label: "(GMT-03:00) UTC-3",
            value: "America/Araguaina"
        },
        {
            label: "(GMT-03:00) Montevideo",
            value: "America/Montevideo"
        },
        {
            label: "(GMT-03:00) Miquelon, St. Pierre",
            value: "America/Miquelon"
        },
        {
            label: "(GMT-03:00) Greenland",
            value: "America/Godthab"
        },
        {
            label: "(GMT-03:00) Buenos Aires",
            value: "America/Argentina/Buenos_Aires"
        },
        {
            label: "(GMT-03:00) Brasilia",
            value: "America/Sao_Paulo"
        },
        {
            label: "(GMT-02:00) Mid-Atlantic",
            value: "America/Noronha"
        },
        {
            label: "(GMT-01:00) Cape Verde Is",
            value: "Atlantic/Cape_Verde"
        },
        {
            label: "(GMT-01:00) Azores",
            value: "Atlantic/Azores"
        },
        {
            label: "(GMT) Greenwich Mean Time : Belfast",
            value: "Europe/Belfast"
        },
        {
            label: "(GMT) Greenwich Mean Time : Dublin",
            value: "Europe/Dublin"
        },
        {
            label: "(GMT) Greenwich Mean Time : Lisbon",
            value: "Europe/Lisbon"
        },
        {
            label: "(GMT) Greenwich Mean Time : London",
            value: "Europe/London"
        },
        {
            label: "(GMT) Monrovia, Reykjavik",
            value: "Africa/Abidjan"
        },
        {
            label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            value: "Europe/Amsterdam"
        },
        {
            label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            value: "Europe/Belgrade"
        },
        {
            label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
            value: "Europe/Brussels"
        },
        {
            label: "(GMT+01:00) West Central Africa",
            value: "Africa/Algiers"
        },
        {
            label: "(GMT+01:00) Windhoek",
            value: "Africa/Windhoek"
        },
        {
            label: "(GMT+02:00) Beirut",
            value: "Asia/Beirut"
        },
        {
            label: "(GMT+02:00) Cairo",
            value: "Africa/Cairo"
        },
        {
            label: "(GMT+02:00) Gaza",
            value: "Asia/Gaza"
        },
        {
            label: "(GMT+02:00) Harare, Pretoria",
            value: "Africa/Blantyre"
        },
        {
            label: "(GMT+02:00) Jerusalem",
            value: "Asia/Jerusalem"
        },
        {
            label: "(GMT+02:00) Minsk",
            value: "Europe/Minsk"
        },
        {
            label: "(GMT+02:00) Syria",
            value: "Asia/Damascus"
        },
        {
            label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
            value: "Europe/Moscow"
        },
        {
            label: "(GMT+03:00) Nairobi",
            value: "Africa/Addis_Ababa"
        },
        {
            label: "(GMT+03:30) Tehran",
            value: "Asia/Tehran"
        },
        {
            label: "(GMT+04:00) Abu Dhabi, Muscat",
            value: "Asia/Dubai"
        },
        {
            label: "(GMT+04:00) Yerevan",
            value: "Asia/Yerevan"
        },
        {
            label: "(GMT+04:30) Kabul",
            value: "Asia/Kabul"
        },
        {
            label: "(GMT+05:00) Ekaterinburg",
            value: "Asia/Yekaterinburg"
        },
        {
            label: "(GMT+05:00) Tashkent",
            value: "Asia/Tashkent"
        },
        {
            label: "GMT+05:00) Islamabad,Karachi",
            value: "Asia/Karachi"
        },
        {
            label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            value: "Asia/Kolkata"
        },
        {
            label: "(GMT+05:45) Kathmandu",
            value: "Asia/Katmandu"
        },
        {
            label: "(GMT+06:00) Astana, Dhaka",
            value: "Asia/Dhaka"
        },
        {
            label: "(GMT+06:00) Novosibirsk",
            value: "Asia/Novosibirsk"
        },
        {
            label: "(GMT+06:30) Yangon (Rangoon)",
            value: "Asia/Rangoon"
        },
        {
            label: "(GMT+07:00) Bangkok, Hanoi, Jakarta",
            value: "Asia/Bangkok"
        },
        {
            label: "(GMT+07:00) Krasnoyarsk",
            value: "Asia/Krasnoyarsk"
        },
        {
            label: "(GMT+08:00) Beijing, Chongqing, Hong Kong,Urumqi",
            value: "Asia/Hong_Kong"
        },
        {
            label: "(GMT+08:00) Irkutsk, Ulaan Bataar",
            value: "Asia/Irkutsk"
        },
        {
            label: "(GMT+08:00) Perth",
            value: "Australia/Perth"
        },
        {
            label: "(GMT+08:45) Eucla",
            value: "Australia/Eucla"
        },
        {
            label: "(GMT+09:00) Osaka, Sapporo, Tokyo",
            value: "Asia/Tokyo"
        },
        {
            label: "(GMT+09:00) Seoul",
            value: "Asia/Seoul"
        },
        {
            label: "(GMT+09:00) Yakutsk",
            value: "Asia/Yakutsk"
        },
        {
            label: "(GMT+09:30) Adelaide",
            value: "Australia/Adelaide"
        },
        {
            label: "(GMT+09:30) Darwin",
            value: "Australia/Darwin"
        },
        {
            label: "(GMT+10:00) Brisbane",
            value: "Australia/Brisbane"
        },
        {
            label: "(GMT+10:00) Hobart",
            value: "Australia/Hobart"
        },
        {
            label: "(GMT+10:00) Vladivostok",
            value: "Asia/Vladivostok"
        },
        {
            label: "(GMT+10:30) Lord Howe Island",
            value: "Australia/Lord_Howe"
        },
        {
            label: "(GMT+11:00) Magadan",
            value: "Asia/Magadan"
        },
        {
            label: "(UTC)",
            value: "UTC"
        }
    ],
    default_currency: "SEK",
    contract_control_currencies: [
        {
            label: "SEK - Swedish Krona",
            value: "SEK"
        },
        {
            label: "EUR - Euro",
            value: "EUR"
        },
        {
            label: "USD - US Dollar",
            value: "USD"
        },
        {
            label: "GBP - UK Pound Sterling",
            value: "GBP"
        },
        {
            label: "NOK - Norwegian Krone",
            value: "NOK"
        },
        {
            label: "DKK - Danish Krone",
            value: "DKK"
        },
        {
            label: "AED - UAE Dirham",
            value: "AED"
        },
        /*{
            label: "AFN - Afghani",
            value: "AFN"
        },
        {
            label: "ALL - Albanian Lek",
            value: "ALL"
        },
        {
            label: "AMD - Armenian Dram",
            value: "AMD"
        },*/
        /*{
            label: "ARS - Argentine Peso",
            value: "ARS"
        },*/
        {
            label: "AUD - Australian Dollar",
            value: "AUD"
        },
        /*{
            label: "AZN - Azerbaijani Manat",
            value: "AZN"
        },
        {
            label: "BAM - Convertible Marks",
            value: "BAM"
        },*/
        /*{
            label: "BDT - Bangladeshi Taka",
            value: "BDT"
        },*/
        /*{
            label: "BGN - Bulgarian Lev",
            value: "BGN"
        },
        {
            label: "BHD - Bahraini Dinar",
            value: "BHD"
        },*/
        /*{
            label: "BND - Brunei Dollar",
            value: "BND"
        },
        {
            label: "BOB - Boliviano",
            value: "BOB"
        },*/
        {
            label: "BRL - Real",
            value: "BRL"
        },
        /*{
            label: "BWP - Pula",
            value: "BWP"
        },*/
        /*{
            label: "BYR - Belarusian Ruble",
            value: "BYR"
        },
        {
            label: "BZD - Belize Dollar",
            value: "BZD"
        },*/
        {
            label: "CAD - Canadian Dollar",
            value: "CAD"
        },
        /*{
            label: "CDF - Congolese Franc",
            value: "CDF"
        },*/
        {
            label: "CHF - Swiss Franc",
            value: "CHF"
        },
        {
            label: "CLP - Chilean Peso",
            value: "CLP"
        },
        /*{
            label: "CNY - PRC Renminbi",
            value: "CNY"
        },*/
        /*{
            label: "COP - Colombian Peso",
            value: "COP"
        },*/
        /*{
            label: "CRC - Costa Rican Colon",
            value: "CRC"
        },*/
        {
            label: "CZK - Czech Koruna",
            value: "CZK"
        },
        /*{
            label: "DOP - Dominican Peso",
            value: "DOP"
        },
        {
            label: "DZD - Algerian Dinar",
            value: "DZD"
        },*/
        /*{
            label: "EGP - Egyptian Pound",
            value: "EGP"
        },*/
        /*{
            label: "ERN - Eritrean Nakfa",
            value: "ERN"
        },
        {
            label: "ETB - Ethiopian Birr",
            value: "ETB"
        },
        {
            label: "GEL - Lari",
            value: "GEL"
        },
        {
            label: "GTQ - Guatemalan Quetzal",
            value: "GTQ"
        },*/
        /*{
            label: "HKD - Hong Kong Dollar",
            value: "HKD"
        },
        /*{
            label: "HNL - Honduran Lempira",
            value: "HNL"
        },
        {
            label: "HRK - Croatian Kuna",
            value: "HRK"
        },*/
        /*{
            label: "HTG - Haitian Gourde",
            value: "HTG"
        },*/
        {
            label: "HUF - Hungarian Forint",
            value: "HUF"
        },
        /*{
            label: "IDR - Indonesian Rupiah",
            value: "IDR"
        },
        {
            label: "ILS - Israeli New Shekel",
            value: "ILS"
        },*/
        /*{
            label: "INR - Indian Rupee",
            value: "INR"
        },*/
        /*{
            label: "IQD - Iraqi Dinar",
            value: "IQD"
        },
        {
            label: "IRR - Iranian Rial",
            value: "IRR"
        },*/
        {
            label: "ISK - Icelandic Krona",
            value: "ISK"
        },
        /*{
            label: "JMD - Jamaican Dollar",
            value: "JMD"
        },*/
        /*{
            label: "JOD - Jordanian Dinar",
            value: "JOD"
        },*/
        {
            label: "JPY - Japanese Yen",
            value: "JPY"
        },
        /*{
            label: "KES - Kenyan Shilling",
            value: "KES"
        },*/
        /*{
            label: "KGS - som",
            value: "KGS"
        },
        {
            label: "KHR - Riel",
            value: "KHR"
        },*/
        {
            label: "KRW - Korean Won",
            value: "KRW"
        },
        /*{
            label: "KWD - Kuwaiti Dinar",
            value: "KWD"
        },
        {
            label: "KZT - Tenge",
            value: "KZT"
        },*/
        /*{
            label: "LAK - Kip",
            value: "LAK"
        },
        {
            label: "LBP - Lebanese Pound",
            value: "LBP"
        },*/
        {
            label: "LKR - Sri Lanka Rupee",
            value: "LKR"
        },
        /*{
            label: "LYD - Libyan Dinar",
            value: "LYD"
        },*/
        /*{
            label: "MAD - Moroccan Dirham",
            value: "MAD"
        },*/
        /*{
            label: "MDL - Moldovan Leu",
            value: "MDL"
        },
        {
            label: "MKD - Macedonian Denar",
            value: "MKD"
        },
        {
            label: "MMK - Myanmar Kyat",
            value: "MMK"
        },
        {
            label: "MNT - Tugrik",
            value: "MNT"
        },
        {
            label: "MOP - Macao Pataca",
            value: "MOP"
        },
        {
            label: "MVR - Rufiyaa",
            value: "MVR"
        },*/
        /*{
            label: "MXN - Mexican Peso",
            value: "MXN"
        },*/
        {
            label: "MYR - Malaysian Ringgit",
            value: "MYR"
        },
        {
            label: "NGN - Nigerian Naira",
            value: "NGN"
        },
        /*{
            label: "NIO - Cordoba",
            value: "NIO"
        },
        {
            label: "NPR - Nepalese Rupees",
            value: "NPR"
        },*/
        /*{
            label: "NZD - New Zealand Dollar",
            value: "NZD"
        },
        {
            label: "OMR - Omani Rial",
            value: "OMR"
        },*/
        /*{
            label: "PAB - Panamanian Balboa",
            value: "PAB"
        },*/
        /*{
            label: "PEN - Peruvian Nuevo Sol",
            value: "PEN"
        },
        {
            label: "PHP - Philippine Peso",
            value: "PHP"
        },*/
        /*{
            label: "PKR - Pakistan Rupee",
            value: "PKR"
        },*/
        {
            label: "PLN - Polish Zloty",
            value: "PLN"
        },
        /*{
            label: "PYG - Paraguay Guarani",
            value: "PYG"
        },*/
        {
            label: "QAR - Qatari Rial",
            value: "QAR"
        },
        {
            label: "RON - Romanian Leu",
            value: "RON"
        },
        {
            label: "RSD - Serbian Dinar",
            value: "RSD"
        },
        {
            label: "RUB - Russian Ruble",
            value: "RUB"
        },
        /*{
            label: "RWF - Rwandan Franc",
            value: "RWF"
        },*/
        {
            label: "SAR - Saudi Riyal",
            value: "SAR"
        },
        {
            label: "SGD - Singapore Dollar",
            value: "SGD"
        },
        /*{
            label: "SOS - Somali Shilling",
            value: "SOS"
        },
        {
            label: "SYP - Syrian Pound",
            value: "SYP"
        },*/
        {
            label: "THB - Thai Baht",
            value: "THB"
        },
        /*{
            label: "TJS - Somoni",
            value: "TJS"
        },
        {
            label: "TMT - Turkmen manat",
            value: "TMT"
        },*/
        /*{
            label: "TND - Tunisian Dinar",
            value: "TND"
        },
        {
            label: "TRY - Turkish Lira",
            value: "TRY"
        },*/
        /*{
            label: "TTD - Trinidad Dollar",
            value: "TTD"
        },*/
        {
            label: "TWD - New Taiwan Dollar",
            value: "TWD"
        },
        /*{
            label: "UAH - Ukrainian Hryvnia",
            value: "UAH"
        },
        {
            label: "UYU - Peso Uruguayo",
            value: "UYU"
        },
        {
            label: "UZS - Uzbekistan Som",
            value: "UZS"
        },
        {
            label: "VEF - Venezuelan Bolivar Fuerte",
            value: "VEF"
        },*/
        /*{
            label: "VND - Vietnamese Dong",
            value: "VND"
        },*/
        /*{
            label: "XAF - CFA Franc BEAC",
            value: "XAF"
        },
        {
            label: "XCD - Eastern Caribbean Dollar",
            value: "XCD"
        },*/
        {
            label: "XOF - CFA",
            value: "XOF"
        },
        /*{
            label: "YER - Yemeni Rial",
            value: "YER"
        },*/
        {
            label: "ZAR - South African Rand",
            value: "ZAR"
        }
    ]
}

export const DOCUMENT_CONTRACT_CARD_SEARCH_PHRASE_MIN_LENGTH = 3;


export const DEFAULT_PRICING_EXAMPLE = '1 000,50';

export const fontFamilies = [
    { name: 'Montserrat, Helvetica, Arial, serif', value: 'Montserrat, Helvetica, Arial, serif' },
    { name: 'Arial', value: 'Arial' },
    { name: 'Comic Sans MS', value: 'Comic Sans MS' },
    { name: 'Courier New', value: 'Courier New' },
    { name: 'Georgia', value: 'Georgia' },
    { name: 'Lucida Sans Unicode', value: 'Lucida Sans Unicode' },
    { name: 'Tahoma', value: 'Tahoma' },
    { name: 'Times New Roman', value: 'Times New Roman' },
    { name: 'Trebuchet MS', value: 'Trebuchet MS' },
    { name: 'Verdana', value: 'Verdana' },
    { name: 'Sans serif', value: 'sans-serif' }
  ];